(function () {
  'use strict';

  var root = document.documentElement;
  var scheduled = false;
  var resizeObserver = null;

  function px(value) {
    return Math.max(0, Math.ceil(value || 0)) + 'px';
  }

  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    if (element.getAttribute('aria-hidden') === 'false') {
      return true;
    }

    return element.classList.contains('is-visible');
  }

  function measure() {
    scheduled = false;

    var cookieBar = document.querySelector('.cookie-bar');
    var stickyBuy = document.querySelector('[data-tdl-sticky-buy]');
    var cookieVisible = isElementVisible(cookieBar);
    var stickyVisible = isElementVisible(stickyBuy);

    root.classList.toggle('tdl-cookie-visible', cookieVisible);
    root.classList.toggle('tdl-sticky-buy-visible', stickyVisible);
    root.style.setProperty('--tdl-cookie-height', px(cookieVisible && cookieBar ? cookieBar.getBoundingClientRect().height : 0));
    root.style.setProperty('--tdl-sticky-buy-height', px(stickyVisible && stickyBuy ? stickyBuy.getBoundingClientRect().height : 0));
    var whatsappBottom = 14;
    [cookieBar, stickyBuy].forEach(function (element) {
      if (isElementVisible(element)) whatsappBottom = Math.max(whatsappBottom, window.innerHeight - element.getBoundingClientRect().top + 12);
    });
    root.style.setProperty('--tdl-whatsapp-bottom', px(whatsappBottom));
    var panelOpen = !!document.querySelector('.mini-cart[aria-hidden="false"], .drawer[aria-hidden="false"], .value-picker[aria-hidden="false"]');
    root.classList.toggle('tdl-commerce-panel-open', panelOpen);
    var whatsapp = document.querySelector('.tdl-whatsapp-float');
    if (whatsapp) whatsapp.inert = panelOpen;
  }

  function scheduleMeasure() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(measure);
  }

  function observeElement(element) {
    if (!element) {
      return;
    }

    new MutationObserver(scheduleMeasure).observe(element, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'style']
    });

    if (resizeObserver) {
      resizeObserver.observe(element);
    }
  }

  function getZoomSource(image) {
    return image && (image.getAttribute('data-zoom') || image.currentSrc || image.src);
  }

  function getProductImages() {
    return Array.prototype.slice.call(document.querySelectorAll('.product-gallery__image[data-zoom]')).filter(function(image) {
      return !!getZoomSource(image) && image.closest('.product-gallery__carousel-item:not(.is-filtered)');
    });
  }

  function buildLightbox() {
    var lightbox = document.querySelector('.tdl-product-lightbox');

    if (lightbox) {
      if (!lightbox.querySelector('.tdl-product-lightbox__nav')) {
        lightbox.parentNode.removeChild(lightbox);
      } else {
        return lightbox;
      }
    }

    lightbox = document.querySelector('.tdl-product-lightbox');

    if (lightbox) {
      return lightbox;
    }

    lightbox = document.createElement('div');
    lightbox.className = 'tdl-product-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Ampliar foto do produto');
    lightbox.innerHTML = [
      '<div class="tdl-product-lightbox__panel">',
      '<button class="tdl-product-lightbox__nav tdl-product-lightbox__nav--prev" type="button" aria-label="Foto anterior">&lsaquo;</button>',
      '<button class="tdl-product-lightbox__close" type="button" aria-label="Fechar imagem ampliada">&times;</button>',
      '<img class="tdl-product-lightbox__image" alt="">',
      '<button class="tdl-product-lightbox__nav tdl-product-lightbox__nav--next" type="button" aria-label="Próxima foto">&rsaquo;</button>',
      '</div>',
      '<div class="tdl-product-lightbox__footer">',
      '<p class="tdl-product-lightbox__caption"></p>',
      '<span class="tdl-product-lightbox__counter" aria-live="polite"></span>',
      '</div>'
    ].join('');

    document.body.appendChild(lightbox);
    return lightbox;
  }

  function closeLightbox() {
    var lightbox = document.querySelector('.tdl-product-lightbox');

    if (!lightbox) {
      return;
    }

    lightbox.classList.remove('is-open');
    document.body.classList.remove('tdl-lightbox-open');
  }

  function setLightboxImage(lightbox, image, index, total) {
    var source = getZoomSource(image);

    if (!source) {
      return;
    }

    var lightboxImage = lightbox.querySelector('.tdl-product-lightbox__image');
    var caption = lightbox.querySelector('.tdl-product-lightbox__caption');
    var counter = lightbox.querySelector('.tdl-product-lightbox__counter');

    lightboxImage.src = source;
    lightboxImage.alt = image.alt || 'Foto ampliada do produto LockStock';
    caption.textContent = image.alt || '';
    if (counter) {
      counter.textContent = total > 1 ? (index + 1) + ' / ' + total : '';
    }
  }

  function openLightbox(image) {
    var images = getProductImages();
    var index = Math.max(0, images.indexOf(image));
    var lightbox = buildLightbox();

    if (!images.length) {
      return;
    }

    lightbox.dataset.currentIndex = String(index);
    setLightboxImage(lightbox, images[index], index, images.length);
    lightbox.classList.add('is-open');
    document.body.classList.add('tdl-lightbox-open');

    var closeButton = lightbox.querySelector('.tdl-product-lightbox__close');
    if (closeButton) {
      closeButton.focus({ preventScroll: true });
    }
  }

  function moveLightbox(direction) {
    var lightbox = document.querySelector('.tdl-product-lightbox.is-open');
    var images = getProductImages();

    if (!lightbox || images.length < 2) {
      return;
    }

    var currentIndex = parseInt(lightbox.dataset.currentIndex || '0', 10);
    var nextIndex = (currentIndex + direction + images.length) % images.length;
    lightbox.dataset.currentIndex = String(nextIndex);
    setLightboxImage(lightbox, images[nextIndex], nextIndex, images.length);
  }

  function syncThumbnailArrowState(scroller) {
    if (!scroller) {
      return;
    }

    var list = scroller.querySelector('.product-gallery__thumbnail-list');
    var previous = scroller.querySelector('[data-gallery-thumbnail-arrow="previous"]');
    var next = scroller.querySelector('[data-gallery-thumbnail-arrow="next"]');

    if (!list || !previous || !next) {
      return;
    }

    var hasOverflow = list.scrollHeight > list.clientHeight + 2;
    var atStart = list.scrollTop <= 2;
    var atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;

    previous.hidden = !hasOverflow;
    next.hidden = !hasOverflow;
    previous.disabled = !hasOverflow || atStart;
    next.disabled = !hasOverflow || atEnd;
    previous.setAttribute('aria-disabled', previous.disabled ? 'true' : 'false');
    next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
  }

  function initProductThumbnailArrows() {
    var scrollers = Array.prototype.slice.call(document.querySelectorAll('.product-gallery--with-thumbnails > .scroller'));

    scrollers.forEach(function(scroller) {
      var list = scroller.querySelector('.product-gallery__thumbnail-list');

      if (list && !list.dataset.tdlThumbnailArrowsReady) {
        list.dataset.tdlThumbnailArrowsReady = 'true';
        list.addEventListener('scroll', function() {
          syncThumbnailArrowState(scroller);
        }, { passive: true });
      }

      syncThumbnailArrowState(scroller);
    });
  }

  function moveProductThumbnails(button) {
    var scroller = button.closest('.product-gallery--with-thumbnails > .scroller');
    var list = scroller && scroller.querySelector('.product-gallery__thumbnail-list');

    if (!list) {
      return;
    }

    var direction = button.getAttribute('data-gallery-thumbnail-arrow') === 'previous' ? -1 : 1;
    var amount = Math.max(120, Math.floor(list.clientHeight * 0.72));
    var target = Math.max(0, Math.min(list.scrollTop + direction * amount, list.scrollHeight - list.clientHeight));

    if (typeof list.scrollTo === 'function') {
      list.scrollTo({ top: target, behavior: 'smooth' });
    } else {
      list.scrollTop = target;
    }

    window.setTimeout(function() {
      syncThumbnailArrowState(scroller);
    }, 350);
  }

  function initProductLightbox() {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStarted = false;

    document.addEventListener('click', function(event) {
      var thumbnailArrow = event.target.closest('[data-gallery-thumbnail-arrow]');

      if (thumbnailArrow) {
        event.preventDefault();
        moveProductThumbnails(thumbnailArrow);
        return;
      }

      var image = event.target.closest('.product-gallery__image[data-zoom]');

      if (image) {
        event.preventDefault();
        openLightbox(image);
        return;
      }

      if (
        event.target.closest('.tdl-product-lightbox__close') ||
        (event.target.classList && event.target.classList.contains('tdl-product-lightbox'))
      ) {
        closeLightbox();
        return;
      }

      if (event.target.closest('.tdl-product-lightbox__nav--prev')) {
        event.preventDefault();
        moveLightbox(-1);
        return;
      }

      if (event.target.closest('.tdl-product-lightbox__nav--next')) {
        event.preventDefault();
        moveLightbox(1);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        moveLightbox(-1);
      } else if (event.key === 'ArrowRight') {
        moveLightbox(1);
      }
    });

    document.addEventListener('touchstart', function(event) {
      if (!document.querySelector('.tdl-product-lightbox.is-open')) {
        return;
      }

      var touch = event.changedTouches && event.changedTouches[0];
      if (!touch) {
        return;
      }

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStarted = true;
    }, { passive: true });

    document.addEventListener('touchend', function(event) {
      if (!touchStarted || !document.querySelector('.tdl-product-lightbox.is-open')) {
        return;
      }

      var touch = event.changedTouches && event.changedTouches[0];
      touchStarted = false;

      if (!touch) {
        return;
      }

      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35) {
        moveLightbox(deltaX > 0 ? -1 : 1);
      }
    }, { passive: true });
  }

  function init() {
    root.classList.add('tdl-layout-refinements-ready');

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleMeasure);
    }

    observeElement(document.querySelector('.cookie-bar'));
    observeElement(document.querySelector('[data-tdl-sticky-buy]'));
    var header = document.querySelector('[data-section-type="header"]') || document.querySelector('header');
    if (header) new MutationObserver(function () {
      var count = header.querySelector('.header__cart-count');
      var link = count && count.closest('a');
      if (link) link.setAttribute('aria-label', 'Carrinho (' + count.textContent.trim() + ')');
      scheduleMeasure();
    }).observe(header, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-hidden'] });
    document.querySelectorAll('.drawer, .value-picker').forEach(observeElement);
    document.addEventListener('keydown', function (event) {
      var panel = document.querySelector('.drawer[aria-hidden="false"], .value-picker[aria-hidden="false"]');
      if (!panel || event.key !== 'Escape') return;
      var close = panel.querySelector('[data-action="close-drawer"], [data-action="close-value-picker"]');
      if (close) {
        event.preventDefault();
        close.click();
        var opener = document.querySelector('[aria-controls="' + panel.id + '"][aria-expanded]');
        if (opener) opener.focus();
      }
    });

    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('resize', initProductThumbnailArrows, { passive: true });
    window.addEventListener('scroll', scheduleMeasure, { passive: true });
    document.addEventListener('shopify:section:load', scheduleMeasure);

    initProductLightbox();
    initProductThumbnailArrows();
    scheduleMeasure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
